import asyncActionTypes from '../../actions/types.js';

const initialState = {
  otpResent: false,
  sessionError: '',
  sessionID: '',
};

const ProfileLogin = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CP_SESSION_TM.START:
      return {
        ...state,
        sessionError: '',
        sessionID: '',
      };
    case asyncActionTypes.RETRIEVE_CP_SESSION_TM.SUCCESS:
      return {
        ...state,
        sessionError: '',
        sessionID: action.payload.id,
      };
    case asyncActionTypes.RETRIEVE_CP_SESSION_TM.FAIL:
      return {
        ...state,
        sessionError: action.payload,
        sessionID: '',
      };
    case asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.START:
      return {
        ...state,
        otpResent: false,
      };
    case asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.SUCCESS:
      return {
        ...state,
        otpResent: true,
      };
    case asyncActionTypes.RETRIEVE_CP_RESEND_OTP_LOGIN.FAIL:
      return {
        ...state,
        otpResent: false,
      };
    default:
      return state;
  }
};

export default ProfileLogin;
